import React from 'react';

import { Button } from '@mui/material';

import SectionNavigation from '~/components/Common/Elements/SectionNavigation';

const GROUPS = [
  'Promotions',
  'Vouchers',
  'Gift cards',
  'Campaigns & audiences',
  'Content & creative',
  'Google Ads',
  'Pricing & placement',
  'Referrals',
  'Agent tools',
] as const;

export type MarketingNavigationGroup = (typeof GROUPS)[number];

interface Props {
  currentTab: string;
  items: Array<{ id: string; label: string; group: MarketingNavigationGroup; restricted: boolean }>;
  showAll: boolean;
  onToggleShowAll: () => void;
  onSelect: (event: React.MouseEvent<HTMLElement>, id: string) => void;
}

export default function MarketingNavigation({ currentTab, items, showAll, onToggleShowAll, onSelect }: Props) {
  return (
    <SectionNavigation
      label="Marketing sections"
      currentTab={currentTab}
      groups={GROUPS.map((label) => ({
        label,
        items: items.filter((item) => item.group === label).map((item) => ({ ...item, href: `/marketing/${item.id}` })),
      }))}
      onSelect={onSelect}
      footer={
        <Button size="small" onClick={onToggleShowAll} sx={{ mt: 1 }}>
          {showAll ? 'Show available sections' : 'Show all sections'}
        </Button>
      }
    />
  );
}
